import {
  PAYRATE_LOADING,
  GET_PAYRATE,
  GET_PAYRATE_SUCCESS,
  GET_PAYRATE_FAIL,
  ADD_PAYRATE_SUCCESS,
  ADD_PAYRATE_FAIL,
  DELETE_PAYRATE_SUCCESS,
  DELETE_PAYRATE_FAIL,
  UPDATE_PAYRATE_SUCCESS,
  UPDATE_PAYRATE_FAIL,
  PAYRATE_RESET
} from "./actionType";

const INIT_STATE = {
  payrates: [],
  error: {},
};

const Payrate = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PAYRATE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PAYRATE:
          return {
            ...state,
            payrates: action.payload.data,
            isPayrateCreated: false,
            isPayrateSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PAYRATE_FAIL:
      switch (action.payload.actionType) {
        case GET_PAYRATE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isPayrateCreated: false,
            isPayrateSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PAYRATE: {
      return {
        ...state,
        isPayrateCreated: false,
        loading: true,
      };
    }

    case PAYRATE_LOADING: {
      return {
        ...state,
        isPayrateCreated: false,
        loading: true,
      };
    }

    case ADD_PAYRATE_SUCCESS:
      return {
        ...state,
        isPayrateCreated: true,
        loading: false,
        payrates: [action.payload.data, ...state.payrates],
      };

    case ADD_PAYRATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PAYRATE_SUCCESS:
      return {
        ...state,
        loading: false,
        payrates: state.payrates.filter(
          payrate => payrate.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PAYRATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PAYRATE_SUCCESS:
      return {
        ...state,
        loading: false,
        payrates: state.payrates.map(payrate =>
          payrate.id.toString() === action.payload.data.id.toString() ? { ...payrate, ...action.payload.data } : payrate
        ),
      };

    case UPDATE_PAYRATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PAYRATE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Payrate;